// Cart persistence — localStorage with 24h TTL.
// Key: 'brazolovers_cart'  Value: { items: [], savedAt: <ISO timestamp> }

const KEY = 'brazolovers_cart';
const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export const loadCart = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.items) || parsed.items.length === 0) return null;
    const savedAt = new Date(parsed.savedAt).getTime();
    if (!savedAt || Date.now() - savedAt > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.items;
  } catch {
    localStorage.removeItem(KEY);
    return null;
  }
};

export const saveCart = (items) => {
  try {
    if (!items || items.length === 0) {
      localStorage.removeItem(KEY);
      return;
    }
    localStorage.setItem(KEY, JSON.stringify({
      items,
      savedAt: new Date().toISOString(),
    }));
  } catch {
    // localStorage may be full or unavailable — fail silently
  }
};

export const clearCart = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};
